import "./styles/InterviewThread.scss";
import InterviewThread from "./js/InterviewThread";

export default InterviewThread;
